<template>
    <div>
        <loading v-if="showLoading"></loading>
        <Breadcrumb v-bind:data="BreadcrumbList"></Breadcrumb>
        <account-status :account_status="account_status"></account-status>

        <div class="widget has-shadow">

            <div class="widget-header bordered  d-flex align-items-center">
                <h2>ویرایش تنوع قیمت -  {{ title }}</h2>
            </div>

            <div class="widget-body">
                <div v-if="account_status=='active'">

                   <div class="alert alert-warning" v-if="warning">
                       {{ warning }}
                   </div>
                    <div class="alert alert-warning">
                        در صورت نیاز به تغییر رنگ یا گارانتی تنوع قیمت لازم هست تنوع قیمت جدید ایجاد نمایید
                    </div>
                    <div class="form-group row">
                        <div class="col-md-3">
                       <label>انتخاب گارانتی : </label>
                        </div>
                        <div class="col-md-9">
                            <div class="select select-color">
                       <select class="selectpicker show-menu-arrow col-md-12" ref="warranty" v-model="warranty_id" data-live-search='true'>
                          <option v-for="(value,key) in warranty" :key="key" v-bind:value="key">{{ value }}</option>
                       </select>
                       <span class="has_error" v-if="warranty_id_error">{{ warranty_id_error }}</span>
                            </div>
                        </div>
                   </div>


                    <div class="form-group row" v-if="color_type==2">
                        <div class="col-md-3">
                            <label>انتخاب سایز : </label>
                        </div>
                        <div class="col-md-9">
                            <div class="select select-color">
                                <select  class="selectpicker show-menu-arrow col-md-12" ref="colors" v-model="color_id"  data-live-search='true'>
                                    <option v-for="color in colors" :value="color.id" :key="color.id">{{ color.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row" v-else>
                        <div class="col-md-3">
                            <label>انتخاب رنگ : </label>
                        </div>
                        <div class="col-md-9">
                            <div class="select select-color">
                                <select class="selectpicker show-menu-arrow col-md-12" ref="colors" v-model="color_id"  data-live-search='true'>
                                    <option v-for="color in colors"  :data-content="getColorOptionContent(color.code,color.name)" :value="'color_'+color.id" :key="color.id"></option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row d-flex align-items-center">
                        <div class="col-md-3">
                            <label>قیمت محصول : </label>
                        </div>
                        <div class="col-md-9">
                            <cleave v-model="price1" :options="options" class="form-control left price_input w-100" placeholder="قیمت مصرف کننده واحد تومان"></cleave>
                            <span class="has_error" v-if="price1_error">{{ price1_error }}</span>
                        </div>
                    </div>

                    <div class="form-group row d-flex align-items-center">
                        <div class="col-md-3">
                            <label>قیمت محصول برای فروش : </label>
                        </div>
                        <div class="col-md-9">
                            <cleave v-model="price2" :options="options" class="form-control left price_input w-100" placeholder="قیمت محصول با تخفیف واحد تومان"></cleave>
                            <span class="has_error" v-if="price2_error">{{ price2_error }}</span>
                        </div>
                    </div>

                    <div class="form-group row d-flex align-items-center">
                        <div class="col-md-3">
                            <label>تعداد سفارش در سبد خرید : </label>
                        </div>
                        <div class="col-md-9">
                            <cleave v-model="product_number_cart" :options="options" class="form-control left price_input w-100" placeholder="تعداد مجاز در هر سفارش"></cleave>
                            <span class="has_error" v-if="product_number_cart_error">{{ product_number_cart_error }}</span>
                        </div>
                    </div>

                    <div class="form-group row d-flex align-items-center">
                        <div class="col-md-3">
                            <label>تعداد موجودی محصول : </label>
                        </div>
                        <div class="col-md-9">
                            <cleave v-model="product_number" :options="options" class="form-control left price_input w-100" placeholder="تعداد موجود در فروشگاه شما"></cleave>
                            <span class="has_error" v-if="product_number_error">{{ product_number_error }}</span>
                        </div>
                    </div>

                    <div class="form-group row d-flex align-items-center">
                        <div class="col-md-3">
                            <label>زمان آماده سازی محصول : </label>
                        </div>
                        <div class="col-md-9">
                            <cleave v-model="send_time" :options="options" class="form-control left price_input w-100" placeholder="زمان تحویل کالا به انبار ما واحد روز (0 = آماده تحویل امروز)"></cleave>
                            <span class="has_error" v-if="send_time_error">{{ send_time_error }}</span>
                        </div>
                    </div>
                    

                    <button class="btn btn-primary"  v-on:click="update()">ویرایش تنوع قیمت</button>
                </div>
                <div v-else>
                   <p style="padding-top:100px;text-align:center;font-size:50px">
                     <span class="fa fa-exclamation"></span>
                   </p>
                   <p style="text-align:center;padding-bottom:80px">شما دسترسی لازم برای عملیات جاری را ندارید</p>
               </div>
           </div>
        </div>

        <server-error-message v-if="server_error"></server-error-message> 
    </div>
</template>

<script>
import Breadcrumb from './Breadcrumb';
import myMinix from '../myMixin';
import AccountStatus from './AccountStatus';
import Loading from './Loading';
import ServerErrorMessage from './ServerErrorMessage';
import Cleave from 'vue-cleave-component';
export default {
    mixins:[myMinix],
    components:{Breadcrumb,Loading,AccountStatus,ServerErrorMessage,Cleave},
    data()
    {
        return {
            account_status:'active',
            showLoading:false,
            title:'',
            server_error:false,
            colors:[],
            warranty:[],
            warranty_id:'',
            color_id:0,
            BreadcrumbList:[
               { path:'/products/warranty/'+this.$route.params.id,title:'مدیریت تنوع های قیمت' },
               { path:'/products/warranty/'+this.$route.params.product_id+'/edit/'+this.$route.params.id,title:'ویرایش تنوع قیمت' },
            ],
            options: {
                delimiter: ',',
                numeral: true,
                numeralDecimalScale:3
            },
            price1:'',
            price1_error:false,
            price2:'',
            price2_error:false,
            product_number_cart:'',
            product_number_cart_error:false,
            send_time_error:false,
            send_time:'',
            product_number:'',
            product_number_error:false,
            warranty_id_error:false,
            send_form:true,
            warning:false,
            color_type:1
        }
    },
    mounted(){
        this.account_status=localStorage.getItem('account_status');
        this.$emit('setSideBarItem','products');
        this.getWarrantyData(this.$route.params.product_id,this.$route.params.id);
    },
    methods:{
        update:function()
        {
            const check_warranty=this.validate_field('گارانتی',this.warranty_id,'warranty_id_error');
            const check_price1=this.validate_field('قیمت محصول',this.price1,'price1_error');
            const check_price2=this.validate_field('قیمت محصول برای فروش',this.price2,'price2_error');
            const check_product_number=this.validate_field('تعداد موجودی محصول',this.product_number,'product_number_error');
            const check_product_number_cart=this.validate_field('تعداد سفارش در سبد خرید',this.product_number_cart,'product_number_cart_error');
            const check_send_time=this.validate_field('زمان آماده سازی محصول',this.send_time,'send_time_error');
            
            if(check_warranty && check_price1 && check_price2 && check_product_number && check_product_number_cart && check_send_time) 
            {
                if(this.send_form)
                {
                   this.send_form=false;
                   const formData=new FormData();
                   formData.append('product_id',this.$route.params.product_id);
                   formData.append('price1',this.price1);
                   formData.append('price2',this.price2);
                   formData.append('product_number',this.product_number);
                   formData.append('product_number_cart',this.product_number_cart);
                   formData.append('send_time',this.send_time);
                   formData.append('_method','PUT');
                   const url=this.$siteUrl+'/api/seller/ProductWarranty/'+this.$route.params.id;
                   this.axios.post(url,formData,this.setHeader()).then(response=>{
                       const result=this.setAccountStatus(response.data);
                       if(result)
                       {
                          if(response.data=='ok')
                          {
                                this.$router.push({name:'ProductWarranty',params:{success:'ok','id':this.$route.params.product_id,'message':'ویرایش تنوع قیمت با موفقیت انجام شد',}})
                          }
                          else if(response.data=='repetitive'){
                               this.send_form=true;
                               this.warning="تنوع قیمت با این گارانتی و رنگ قبلا توسط شما ثبت شد در صورت نیاز به تغییر هزینه میتواند از قسمت مدیریت گارانتی ها هزینه را ویرایش نمایید";
                          }
                          else{
                               this.send_form=true;
                               this.show_server_error();
                          }                          
                       }

                       
                   }).catch((error)=>{
                       this.send_form=true;
                       this.setCatch(error);
                   });
                }

            }
        }
    }
}
</script>

<style>

</style>